import React, { useEffect } from 'react';
import { CoreLink } from 'components/core/library/link';
import { overwriteDisplayName } from '@sparefoot/react-core/tracking-lib';
import { matchPath } from 'react-router-dom';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { staticRoutes } from 'routes';
import './Link.scss';

function Link(props) {
	const {
		href,
		to,
		onClick,
		rel,
		target,
		className,
		children,
		color,
		hideBorder,
		inheritFont,
		productClick,
	} = props;
	return (
		<CoreLink
			href={href}
			to={to}
			onClick={onClick}
			rel={rel}
			target={target}
			className={classnames(className, color, {
				'hide-border': hideBorder,
				inheritFont,
			})}
			productClick={productClick}
		>
			<span className={classnames('link-content', color)}>
				{children}
			</span>
		</CoreLink>
	);
}

Link.propTypes = {
	href: PropTypes.string,
	to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	onClick: PropTypes.func,
	rel: PropTypes.string,
	target: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
	color: PropTypes.string,
	hideBorder: PropTypes.bool,
	inheritFont: PropTypes.bool,
	productClick: PropTypes.func,
};

export const enhance = (Component) => {
	const EnhancedLink = ({
		className,
		secondary,
		tertiary,
		quaternary,
		underline,
		preloadRoute,
		...rest
	}) => {
		const enhancedClassName = classnames(
			'ss-link',
			{ 'ss-link-secondary': secondary },
			{ 'ss-link-tertiary': tertiary },
			{ 'ss-link-quaternary': quaternary },
			{ 'ss-link-underline': underline },
			className,
		);

		useEffect(() => {
			if (preloadRoute) {
				const { to } = rest;
				const matchingRoute = staticRoutes.find((route) =>
					matchPath(
						{ path: route.path || '', end: true },
						to?.split('?')[0],
					),
				);
				if (matchingRoute?.component.preload) {
					matchingRoute.component.preload();
				}
			}
		}, []); // eslint-disable-line react-hooks/exhaustive-deps

		if (!preloadRoute) {
			return (
				<Component
					{...rest}
					className={enhancedClassName}
					secondary={secondary}
					tertiary={tertiary}
					quaternary={quaternary}
					underline={underline}
				/>
			);
		}

		return (
			<Component
				{...rest}
				className={enhancedClassName}
				secondary={secondary}
				tertiary={tertiary}
				quaternary={quaternary}
				underline={underline}
			/>
		);
	};
	EnhancedLink.propTypes = {
		className: PropTypes.string,
		secondary: PropTypes.bool,
		tertiary: PropTypes.bool,
		quaternary: PropTypes.bool,
		underline: PropTypes.bool,
		preloadRoute: PropTypes.bool,
	};
	return overwriteDisplayName('Link')(EnhancedLink);
};

export default enhance(Link);
